import BlogCard from './BlogCard'

export default function Blog({ initialData }) {
  return (
    <>
    <div className="blogpage header-gap">
        <div className="container">
            <div className="row">
                <div className="col-lg-6 col-sm-6">
                    <span>Our Blogs</span>
                    <h1 className="heading">Why A Well-Planned Interior Is Necessary</h1>
                    <p>Discover the latest interior design ideas, trends, and tips for creating functional spaces that reflect your unique style.</p>
                </div>
            </div>
        </div>

        <img src="/image/bloghead.webp" className="image-bloghead" alt="blog"/>
    </div> 

    <BlogCard initialBlogs={initialData?.blogs} />
    </>
  )
}
